// Preferences-domain HTTP service (Layer 2 — transport). Plan 023 / A5.
// See apps/backend/app/domains/identity/routes.py: GET /api/me,
// GET/PATCH /api/me/preferences.
import { request } from '@/lib/http'
import type { Organization, Preferences, PreferencesResponse, User } from '@/types'

export interface IdentityResponse {
  user: User | null
  org: Organization | null
  // null for a genuinely org-less caller (plan 024 / ADR-0009) — the shape
  // RequireOrg reads to decide whether to route to /setup-organization.
  role: string | null
  preferences: Preferences
  orgs: Array<{ id: number; role: string; name: string | null }>
}

/** Only timezone/date_format/work_start_min/work_end_min are patchable —
 * working_days 400s (ADR-0008). An explicit `null` clears the override back
 * to inheriting the org's value. */
export interface UpdatePreferencesData {
  timezone?: string | null
  date_format?: string | null
  work_start_min?: number | null
  work_end_min?: number | null
}

export const preferencesApi = {
  /** GET /api/me — org + role + resolved preferences + the orgs list. */
  getIdentity(): Promise<IdentityResponse> {
    return request('/me')
  },

  getPreferences(): Promise<PreferencesResponse> {
    return request('/me/preferences')
  },

  updatePreferences(data: UpdatePreferencesData): Promise<PreferencesResponse> {
    return request('/me/preferences', { method: 'PATCH', body: JSON.stringify(data) })
  },
}
